import { useMemo } from 'react';

import { useAppSelector } from '@/store/hooks';
import useSessionUuidParams from './use-session-uuid-params';
import { selectFirstSessionUuid } from '@/store/slices/project/selectors';

const useParamsOrFirstSessionUuid = () => {
  const paramsSessionUuid = useSessionUuidParams();
  const firstSessionUuid = useAppSelector(selectFirstSessionUuid);

  return useMemo(() => {
    return paramsSessionUuid ? paramsSessionUuid : firstSessionUuid;
  }, [firstSessionUuid, paramsSessionUuid]);
};

export default useParamsOrFirstSessionUuid;
